import { apiGet } from './api';

export interface Task {
  name: string;
  description: string;
  ml_flow_run_name: string;
}

// List of tasks the robot is configured to run, each paired with the
// MLflow checkpoint run currently used for it. Served by the dashboard
// backend from ~/tasks.json.
export async function fetchTasks(): Promise<Task[]> {
  return apiGet<Task[]>('/data/tasks');
}
